import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface BusinessActivitiesDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
const BusinessActivitiesDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: BusinessActivitiesDeleteProps) => {
  const { t } = useTranslation();
  return (
    <CustomSharedConfirmationModal
      open={open}
      title={`${t("delete")} ${t("type_of_business")}`}
      description={t("delete_resource_description", { name: t("type_of_business") })}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};
export default BusinessActivitiesDelete;
